import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AmdocsDeviceService, AmdocsEventBusService, AmdocsTimeService, ApiError, DropdownItem} from 'amdocs-core';
import {FormControl} from '@angular/forms';
import {EWhenDays, IWhen} from '../../../models/user-map';
import {SelectedMapFiltersDetailsService} from '../../../core/selected-map-filters-details.service';
import {IDefaultTimeRange, ISiteParametersRegions, SelectedMapFiltersDetails} from '../../../models';
import {CONSTANTS} from '../../../constants';
import {catchError, finalize, first, map, mergeMap} from 'rxjs/operators';
import {Observable, of, throwError} from 'rxjs';
import {ApiService} from '../../../core/api.service';
import {FoundationService} from '../../../core/foundation.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-select-when',
  templateUrl: './select-when.component.html',
  styleUrls: ['./select-when.component.scss']
})

export class SelectWhenComponent implements OnInit {

  private firstDateChange = true;
  public hasChanges = false;
  public amdocsDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  public datepickerConfig: any;
  public storageKey = 'filter-when';
  public fromItems: DropdownItem[] = [];
  public fromCtrl: FormControl = new FormControl();
  public invalidFromTo = false;
  public toItems: DropdownItem[] = [];
  public toCtrl: FormControl = new FormControl();
  public currentDate: string;
  public setAsDefaultCtrl: FormControl = new FormControl();
  public minDate: string;
  public maxDate: string;
  @Input() when: IWhen;
  @Input() defaultTimeRange: IDefaultTimeRange;
  @Output() cancelCallback: EventEmitter<null> = new EventEmitter<null>();
  @Output() genericApiErrorCB = new EventEmitter<ApiError>();

  public currentTime: Date = new Date();

  constructor(private apiService: ApiService,
              private deviceService: AmdocsDeviceService,
              private foundationService: FoundationService,
              private timeService: AmdocsTimeService,
              private selectedMapFiltersDetailsService: SelectedMapFiltersDetailsService,
              private eventBusService: AmdocsEventBusService, private datePipe: DatePipe) {
  }


  ngOnInit(): void {
    this.selectedMapFiltersDetailsService.getSelectedMapFiltersDetails().pipe(
      catchError((error: ApiError) => {
        this.genericApiErrorCB.emit(error)
        return throwError(error);
      }),
    ).subscribe((filters: SelectedMapFiltersDetails) => {
      if (!this.when) {
        this.when = filters.when;
      }
      this.initDropdowns();
      
      setTimeout(() => {
        // Normalize time values to HH:00 format to match dropdown items
        const normalizeTimeToHour = (time: string): string => {
          if (!time) return '09:00';
          if (time.match(/^\d{2}:00$/)) return time;
          
          const [hours, minutes] = time.split(':').map(Number);
           const roundedHours = minutes > 30 ? (hours + 1) % 24 : hours;
          return String(roundedHours).padStart(2, '0') + ':00';
        };
      
        const normalizedFrom = normalizeTimeToHour(this.when.from);
        const normalizedTo = normalizeTimeToHour(this.when.to);
      
        // Ensure values exist in dropdown items
        const fromValue = this.fromItems.length > 0 && this.fromItems.some(item => item.key === normalizedFrom) 
          ? normalizedFrom 
          : (this.fromItems[0]?.key || '09:00');
          
        const toValue = this.toItems.length > 0 && this.toItems.some(item => item.key === normalizedTo) 
          ? normalizedTo 
          : (this.toItems[0]?.key || '18:00');
      
        // Set normalized values
        this.fromCtrl.setValue(fromValue);
        this.toCtrl.setValue(toValue);
      }, 0);
      console.log('WhenCurrent:', this.when.date);
      // Fix timezone issue for currentDate: Format with time component to prevent date shifts
      if (this.when.date) {
        // Check if date is in YYYY-MM-DD format (without time component)
        if (this.when.date.match(/^\d{4}-\d{2}-\d{2}$/)) {
          // Parse as local date and format with noon time to avoid timezone shifts
          const [yearStr, monthStr, dayStr] = this.when.date.split('-');
          const dateObj = new Date(parseInt(yearStr), parseInt(monthStr) - 1, parseInt(dayStr), 12, 0, 0, 0);
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          this.currentDate = `${year}-${month}-${day}T12:00:00`;
        } else {
          // Already has time component, use as-is
          this.currentDate = this.when.date;
        }
      } else {
        // No date provided, use today with noon time
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        this.currentDate = `${year}-${month}-${day}T12:00:00`;
      }
      console.log("NewCurrentDate:", this.currentDate);
      this.eventBusService.emit(CONSTANTS.EVENTS.TOGGLE_FULL_PAGE_LOADER, true);
      this.apiService.loadSystemParameters().pipe(
        mergeMap((params: ISiteParametersRegions) => {
          const sessionRegion = JSON.parse(sessionStorage.getItem('selectLocationClient'))?.country?.region;
          const region = sessionRegion ? sessionRegion : this.foundationService.region.toString();
          const siteParam = params.systemParameters.find(p => p.regionCode === region);
          if (siteParam) {
            if (!this.fromCtrl.value) {
              this.fromCtrl.setValue(siteParam.defaultStartTime);
            }
            if (!this.toCtrl.value) {
              this.toCtrl.setValue(siteParam.defaultEndTime);
            }
            /*const allowedDays = [];
            const moment = this.timeService.moment();
            //this.minDate = this.timeService.moment().format('YYYY-MM-DD');
            this.minDate = moment.format('YYYY-MM-DD, h:mm:ss a');
            allowedDays.push(moment.day());
            for (let i = 1; i < siteParam.advBookingPeriod; i++) {
              moment.add(1, 'day');
            }
            if (filters.selectLocationClient?.country?.code === 'ISR') {
              if (moment.day() === EWhenDays.thursday) {
                moment.add(2, 'day');
              }
            } else {
              if (moment.day() === EWhenDays.friday) {
                moment.add(2, 'day');
              }
            }
            //this.maxDate = moment.format('YYYY-MM-DD');
            this.maxDate = moment.format('YYYY-MM-DD, h:mm:ss a');
            this.datepickerConfig = {};*/

            const allowedDays = [];
            const currentDate = new Date();
           // this.minDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
                      // Fix timezone issue for minDate: Format date with time component
            const minDateObj = new Date(); // Today's date
            minDateObj.setHours(0, 0, 0, 0); // Start of day in local timezone

            const minYear = minDateObj.getFullYear();
            const minMonth = String(minDateObj.getMonth() + 1).padStart(2, '0');
            const minDay = String(minDateObj.getDate()).padStart(2, '0');
            const minHours = String(minDateObj.getHours()).padStart(2, '0');
            const minMinutes = String(minDateObj.getMinutes()).padStart(2, '0');
            const minSeconds = String(minDateObj.getSeconds()).padStart(2, '0');

            this.minDate = `${minYear}-${minMonth}-${minDay}T${minHours}:${minMinutes}:${minSeconds}`;
            console.log("this.minDate", this.minDate);
            console.log("currentDate", currentDate);
            console.log("currentDate.getDay()", currentDate.getDay());
            allowedDays.push(currentDate.getDay());
            console.log("allowedDays", allowedDays);
            
            for (let i = 1; i < siteParam.advBookingPeriod; i++) {
              currentDate.setDate(currentDate.getDate() + 1);
              if (filters.selectLocationClient?.country?.code === 'ISR') {
                if (currentDate.getDay() === EWhenDays.friday) {
                  siteParam.advBookingPeriod++;
                }
                if (currentDate.getDay() === EWhenDays.saturday) {
                  siteParam.advBookingPeriod++;
                }
              } else {
                if (currentDate.getDay() === EWhenDays.saturday) {
                  siteParam.advBookingPeriod++;
                }
                if (currentDate.getDay() === EWhenDays.sunday) {
                  siteParam.advBookingPeriod++;
                }
              }

            }

            if (filters.selectLocationClient?.country?.code === 'ISR') {
              if (currentDate.getDay() === EWhenDays.thursday) {
                currentDate.setDate(currentDate.getDate() + 2);
              }
            } else {
              if (currentDate.getDay() === EWhenDays.friday) {
                currentDate.setDate(currentDate.getDate() + 2);
              }
            }
           // currentDate.setDate(currentDate.getDate() - 16); // Adds 24 days testing timezone issue
           // this.maxDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
           // console.log("maxDate", this.maxDate);
            // // Fix timezone issue: Format date with time component to ensure local timezone parsing
            const maxDateObj = new Date(currentDate);
            maxDateObj.setHours(23, 59, 59, 999); // Set to end of day in local timezone

            // Format with time component - ensures it's parsed as local time, not UTC
            const year = maxDateObj.getFullYear();
            const month = String(maxDateObj.getMonth() + 1).padStart(2, '0');
            const day = String(maxDateObj.getDate()).padStart(2, '0');
            const hours = String(maxDateObj.getHours()).padStart(2, '0');
            const minutes = String(maxDateObj.getMinutes()).padStart(2, '0');
            const seconds = String(maxDateObj.getSeconds()).padStart(2, '0');

            // Format as "YYYY-MM-DDTHH:mm:ss" - includes time, parsed as local time
            this.maxDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
            console.log("this.maxDate", this.maxDate);
            this.datepickerConfig = {};

          } else {
            this.datepickerConfig = {};
          }
          this.onChangedTime();

          return of(params);
        }),
        catchError((error: ApiError) => {
          this.genericApiErrorCB.emit(error)
          return throwError(error);
        }),
        finalize(() => {
          this.eventBusService.emit(CONSTANTS.EVENTS.TOGGLE_FULL_PAGE_LOADER, false);
        }),
        first()
      ).subscribe();
    });
  }

  onDateChanged(date: string): void {
    if (!this.firstDateChange) {
      this.hasChanges = true;
    }
    this.firstDateChange = false;
    console.log('changeDate:', date);
    // Fix timezone issue: Format date with time component to prevent date shifts
    if (date && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
      // Parse as local date and format with noon time to avoid timezone shifts
      const [yearStr, monthStr, dayStr] = date.split('-');
      const dateObj = new Date(parseInt(yearStr), parseInt(monthStr) - 1, parseInt(dayStr), 12, 0, 0, 0);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      this.currentDate = `${year}-${month}-${day}T12:00:00`;
    } else {
      // Already has time component or invalid format, use as-is
      this.currentDate = date;
    }
    console.log("CurrentChangeDate:", this.currentDate);

  }

  onChangedTime(): void {
    this.hasChanges = true;

    this.invalidFromTo = false;
    if (this.fromCtrl.value > this.toCtrl.value) {
      this.invalidFromTo = true;
      return;
    }
  }

  initDropdowns(): void {
    const disabled = false;
    for (let i = 0; i < 24; i++) {
      const value = i < 10 ? '0' + i + ':00' : `${i}:00`;
      const key = value;
      this.fromItems.push({
        key, value, disabled
      });
      this.toItems.push({
        key, value, disabled
      });
    }
  }

  cancel(event): void {
    event.stopPropagation();
    this.cancelCallback.emit();
  }

  submit(event): void {
    // this.invalidFromTo = false;
    // if (this.fromCtrl.value > this.toCtrl.value) {
    //   this.invalidFromTo = true;
    //   return;
    // }
    this.saveDefault().pipe(
      map((res) => {
        this.setValuesInStorage();
        this.cancel(event);
      }),
      catchError((error: ApiError) => {
        this.genericApiErrorCB.emit(error);
        return throwError(error);
      }),
    ).subscribe();
  }

  public setValuesInStorage(): void {
    const when: IWhen = {
      date: this.currentDate.split('T')[0], // Extract YYYY-MM-DD from YYYY-MM-DDTHH:mm:ss
      from: this.fromCtrl.value,
      to: this.toCtrl.value
    };
    if (this.invalidFromTo) {
      when.endDate = this.timeService.moment(this.currentDate).add(1, 'day').format('YYYY-MM-DD');
    }
    this.selectedMapFiltersDetailsService.setWhenCache(when);
    if (!this.deviceService.isMobile()) {
      this.eventBusService.emit(CONSTANTS.EVENTS.USER_MAP_NAVIGATION, {when});
    }
  }

  public saveDefault(): Observable<boolean> {
    if (this.setAsDefaultCtrl.value) {
      const from = this.fromCtrl.value;
      const to = this.toCtrl.value;
      return this.apiService.setDefaultTimeRangeQuery(from, to);
    }
    return of(true);
  }

}
